var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "management-page-outer-container" },
    [
      _c("router-view"),
      _vm._v(" "),
      _vm.$route.name === "asset-reservations"
        ? _c("reservations-list", {
            attrs: { "workspace-uuid": _vm.workspaceUUID, search: _vm.search },
            on: {
              "update-workspace-uuid": function($event) {
                _vm.workspaceUUID = $event
              },
              "update-search": function($event) {
                _vm.search = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4aa1c102", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa1c102","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Data/AssetReservations.vue
// module id = null
// module chunks = 